// @TODO <HEALTH2019>
App.factory('zochaUnifiedInsuranceService', ['$q', 'baseService', 'Config', function($q, baseService, Config) {
    function ZochaUnifiedInsuranceService() {

        this.enterOriginalCopyBarcode = function(id) {
            return baseService.post(Config.API_URL + '/zocha/barcode/' + encodeURIComponent(id) + '/enterOriginalCopy').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.enterOriginalCopyBarcodeBody = function(id) {
            let data = {
                barcode: id
            };
            return baseService.post(Config.API_URL + '/zocha/barcode/enterOriginalCopy', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };
    }

    return new ZochaUnifiedInsuranceService();
}]);
// @TODO </HEALTH2019>
